module.exports = __webpack_public_path__ + "6a1135c794bdea22d7941a30d651cfb9.png";